/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Mix_LabelInputs */



/**
* | output |
* | --- |
* | "Mix" |
*
* @param {Audio_Description_Export_Automix_Mix_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_mix_label = /** @type {((inputs?: Audio_Description_Export_Automix_Mix_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Mix_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mix")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mischen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mescolare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Смешивание")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mezcla")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("混合")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ミックス")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मिक्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mistura")
	return /** @type {LocalizedString} */ ("Mix")
});